package one.healthium.domain.user.models

data class SymptomInfoModel(
    val kind: SymptomKind,
    val severities: List<SymptomSeverity>,
)
